<template>
  <div class="scroll-content">
    <popup-content v-for="singlePoint in pointsDetailsSorted" :key="singlePoint.key" class="popup-content" :data-loaded="dataLoaded"
                   :point-details="singlePoint" />
  </div>
</template>

<script>
import PopupContent from './popup-content'

export default {
  components: { PopupContent },

  props: {
    points: {
      type: Array,
      required: true
    },
    pointsDetails: {
      type: Array,
      required: true
    },
    dataLoaded: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    /*
    The sort order is that "Groups" are at the bottom, sorted alphabetically by title. Before that are "Events" and
    "External Events" grouped together sorted by start date.
     */
    pointsDetailsSorted() {
      return [...this.pointsDetails].sort((a, b) => {
        if (a.type === 'Group' && b.type === 'Group') {
          return a.title.toLowerCase() - b.title.toLowerCase()
        } else if (a.type === 'Group' || b.type === 'Group') {
          return a.type === 'Group' ? 1 : -1
        } else {
          return Date.parse(a.startAt) - Date.parse(b.startAt)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~friendship_styles/colors" as colors;

.scroll-content {
  overflow-y: scroll;
  max-height: 300px;
}

.popup-content:not(:last-child) {
  border-bottom: 1px solid colors.$unobtrusive-text-color;
  padding: 5px 0;
}
</style>
